import script from "./celebrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./celebrationView.vue?vue&type=script&setup=true&lang=js"

import "./celebrationView.vue?vue&type=style&index=0&id=270dc3d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270dc3d4"]])

export default __exports__